<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  props: ["title", "labels", "data", "ratio"],
  data() {
    return {};
  },
  mounted() {
    this.load();
  },
  watch: {
    data() {
      this.load();
    },
  },
  methods: {
    load() {
      this.renderChart(
        {
          labels: this.$props.labels,
          datasets: [
            {
              label: "AF",
              maxBarThickness: 30,
              backgroundColor: "#FF0000",
              data: this.$props.data[0],
              datalabels: {
                display: false,
              },
            },
            {
              label: "LA",
              maxBarThickness: 30,
              backgroundColor: "#FF7F50",
              data: this.$props.data[1],
              datalabels: {
                display: false,
              },
            },
            {
              label: "EU",
              maxBarThickness: 30,
              backgroundColor: "#FFA500",
              data: this.$props.data[2],
              datalabels: {
                display: false,
              },
            },
            {
              label: "OC",
              maxBarThickness: 30,
              backgroundColor: "#FFFF00",
              data: this.$props.data[3],
              datalabels: {
                display: false,
              },
            },
            {
              label: "ASIA",
              maxBarThickness: 30,
              backgroundColor: "#90EE90",
              data: this.$props.data[4],
              datalabels: {
                display: false,
              },
            },
            {
              label: "ME",
              maxBarThickness: 30,
              backgroundColor: "#66CDAA",
              data: this.$props.data[5],
              datalabels: {
                display: false,
              },
            },
            {
              label: "CN",
              maxBarThickness: 30,
              backgroundColor: "#00FFFF",
              data: this.$props.data[6],
              datalabels: {
                display: false,
              },
            },
            {
              label: "CIS",
              maxBarThickness: 30,
              backgroundColor: "#87CEEB",
              data: this.$props.data[7],
              datalabels: {
                display: false,
              },
            },
            {
              label: "NA",
              maxBarThickness: 30,
              backgroundColor: "#4169E1",
              data: this.$props.data[8],
              datalabels: {
                display: false,
              },
            },
            {
              label: "KO",
              maxBarThickness: 30,
              backgroundColor: "#0000FF",
              data: this.$props.data[9],
              datalabels: {
                display: false,
              },
            },
          ],
        },
        {
          tooltips: {
            mode: "index",
            intersect: false,
            callbacks: {
              footer: function (data) {
                var total = 0;
                for (var i = 0; i < data.length; i++) {
                  total += data[i].xLabel;
                }
                return "Total: " + total;
              },
              label: function (tooltipItem, data) {
                var value = null;
                if (tooltipItem.xLabel > 0) {
                  value =
                    data.datasets[tooltipItem.datasetIndex].label +
                    " : " +
                    tooltipItem.xLabel;
                }
                return value;
              },
            },
          },
          responsive: true,
          maintainAspectRatio: this.$props.ratio,
          scales: {
            xAxes: [
              {
                stacked: true,
                categoryPercentage: 0.5,
                barPercentage: 1,
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
              },
            ],
          },
          // legend: {
          //   display: false,
          // },
        }
      );
    },
  },
};
</script>
